import { AiSummaryKind } from '../constants';

/**
 * Locate the (single) RICH_TEXT attribute flagged with an AI Summary kind
 * inside a form template, returning the full react-hook-form path
 * (`sections.X.attributes.Y.value`).
 *
 * Path-based addressing is required: attribute `name` is NOT unique across a
 * form (e.g. all RICH_TEXTs default to `'richText'`), so name-keyed helpers
 * silently match the first one — wrong field for AI streaming when a regular
 * RICH_TEXT precedes the AI Summary one.
 *
 * The marker on `properties.aiSummary` is an `AiSummaryKind` enum value (not
 * a boolean) so we can extend to other AI-fill kinds without rewiring this
 * lookup. Currently only SESSION_SUMMARY exists.
 *
 * @param {object} form  loaded form template (typically `state.forms.form`)
 * @returns {{ path: string, kind: string }|null}
 */
export const findAiSummaryAttribute = (form) => {
    const sections = form?.sections;
    if (!Array.isArray(sections)) return null;
    const validKinds = new Set(Object.values(AiSummaryKind));
    for (let s = 0; s < sections.length; s++) {
        const attributes = sections[s]?.attributes;
        if (!Array.isArray(attributes)) continue;
        for (let a = 0; a < attributes.length; a++) {
            const attr = attributes[a];
            const kind = attr?.properties?.aiSummary;
            if (attr?.type === 'RICH_TEXT' && validKinds.has(kind)) {
                return { path: `sections.${s}.attributes.${a}.value`, kind };
            }
        }
    }
    return null;
};
